







import { Vue, Component, Prop } from 'vue-property-decorator';
import { EParagraphSize } from '@getaccept/lib-ui';

@Component({
  data: () => ({
    EParagraphSize,
  }),
})
export default class ChatTimestamp extends Vue {
  @Prop() date: string;
  @Prop() time: string;
}
